import {
    createSlice
} from '@reduxjs/toolkit';

const initialState = {
    "member.id": "",
    "member.authId": "",
    "member.name": "",
    "member.role": "",
    "member.createdDate": "",
    "member.updatedDate": "",
};

const memberReducer = createSlice({
    name: 'member',
    initialState,
    reducers: {
        /**
         * 사용자 정보 초기화
         * @param {Object} action.payload - 사용자 정보 객체
         */
        initMemberInfo: (state, action) => {
            return {
                ...state,
                ...action.payload
            };
        },

        /**
         * 사용자 정보 업데이트
         * @param {Object} action.payload - 업데이트할 사용자 정보
         */
        updateMemberInfo: (state, action) => {
            return {
                ...state,
                ...action.payload
            };
        },

        /**
         * 사용자 정보 초기화
         */
        clearMemberInfo: () => {
            return initialState;
        },
    },
});

export const {
    initMemberInfo,
    updateMemberInfo,
    clearMemberInfo
} = memberReducer.actions;

export default memberReducer.reducer;
